import { Modal } from "antd";
import React from "react";
import styles from "./InfoModalCompanent.module.scss";
import { ExclamationCircleOutlined } from "@ant-design/icons";

interface InfoModalProps {
  message: string;
  title: string;
  okText: string;
  loginText?: string;
  onClose?: () => void;
}

const InfoModalComponent = ({
  message,
  title,
  okText,
  loginText,
  onClose,
}: InfoModalProps) => {
  const modal = Modal.confirm({
    title: title,
    content: <p>{message}</p>,
    icon: <ExclamationCircleOutlined style={{ color: "#faad14" }} />,
    footer: null,
    closable: true,
  });

  modal.update({
    footer: (
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
          marginTop: "30px",
        }}
      >
        <button
          onClick={() => {
            modal.destroy();
            if (onClose) onClose();
          }}
          className={styles.okButton}
        >
          {okText}
        </button>
        {loginText && (
          <button
            onClick={() => {
              window.location.href = "/login";
              modal.destroy();
            }}
            className={styles.loginButton}
          >
            {loginText}
          </button>
        )}
      </div>
    ),
  });

  return null;
};

export default InfoModalComponent;
